export default __webpack_public_path__ + "Revenue_Calculator_New_Product_Template_FE-zh-CN.306d41c9.xlsx";